import React from "react";
import PropTypes from "prop-types";
import { t } from "../../../../helpers/translator";
import { openCasinoGame } from "../helpers";


const CasinoGame = ({ game, isFavorite, toggleFavorite, disableFavoriteIcon = true }) => (
    <div className="single-casino-game-view">
        <div className="casino-game-info-view">
            <span className="game-screen-view" onClick={() => openCasinoGame(game)}>
                <img src={game.icon_1 || game.icon_2} />
            </span>
            <p className="casino-game-title">
                <b>{t(game.name)}</b>
                { disableFavoriteIcon && <i className={`favorite-game-star ${isFavorite ? 'active' : ''}`} onClick={() => toggleFavorite(game)} />}
            </p>
        </div>
    </div>
);

CasinoGame.propTypes = {
    game: PropTypes.object,
    isFavorite: PropTypes.bool,
    toggleFavorite: PropTypes.func,
};

export default CasinoGame;